import React, { useContext, useMemo } from 'react';

import { House } from '@r1-frontend/ui-react/components/svg/building';
import { Electricity } from '@r1-frontend/ui-react/components/svg/devices';
import { CalendarSecond, Clock } from '@r1-frontend/ui-react/components/svg/time';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import ListItemWithIcon from '@r1-frontend/ui-react/organisms/ListItemWithIcon';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { FullBuyContext, TFullBuyContextProperties } from '~/src/features/full-buy/analytics/context';
import InfoBlock from '~/src/features/full-buy/InfoBlock';

interface IProps {
    date?: string,
    sla?: string,
    isInstallationHardware: boolean,
}

const getEngineerText = (isVillage = false) => {
    return isVillage
        ? `Просверлит необходимое отверстие и&nbsp;проложит кабель от&nbsp;оборудования провайдера к&nbsp;вам домой.<br />
        Если интернет-кабель у&nbsp;вас уже есть&nbsp;&mdash; проверит его и&nbsp;заменит при необходимости.<br />
        Настроит оборудование и&nbsp;покажет, как всё работает.<br />
        Поможет оплатить услуги через сайт или мобильное приложение &laquo;Мой Дом.ру&raquo;.<br />
        Если понадобится кабель длиннее 5&nbsp;метров, за&nbsp;дополнительные метры нужно будет доплатить.
    `
        : `Просверлит отверстие между квартирой и&nbsp;подъездом и&nbsp;проложит кабель.<br/>
        Если интернет-кабель в&nbsp;квартире уже есть&nbsp;&mdash; проверит его и&nbsp;заменит при необходимости.<br/>
        Если кабеля потребуется более 5&nbsp;метров, каждый дополнительный метр оплачивается отдельно.<br/>
        Настроит оборудование и&nbsp;покажет, как всё работает. А&nbsp;ещё поможет оплатить услуги через сайт или мобильное приложение &laquo;Мой Дом.ру&raquo;.
    `;
};

const getHowToPrepareText = (isInstallationHardware = false) => {
    let text = '';

    if (isInstallationHardware) {
        text += 'Выберите и&nbsp;освободите место для роутера или ТВ-приставки.<br />';
    }

    text += `Держите под рукой паспорт, логин и&nbsp;пароль от&nbsp;Госуслуг для оформления электронного договора.<br />
        Убедитесь, что ваши телевизор, компьютер или ноутбук исправны.<br />
        Заранее пополните баланс на&nbsp;карте. Оплатить услуги можно только онлайн на&nbsp;сайте или через мобильное приложение.`;

    return text;
};

const EmployeeVisit = ({ date, sla, isInstallationHardware }: IProps): JSX.Element => {
    const { isVillage } = useContext<TFullBuyContextProperties>(FullBuyContext);
    const engineerText = useMemo(() => getEngineerText(isVillage), [isVillage]);
    const howToPrepareText = useMemo(() => getHowToPrepareText(isInstallationHardware), [isVillage, isInstallationHardware]);

    return (
        <InfoBlock header={'Визит инженера'}>
            <ListItemWithIcon
                isBiggerFont={true}
                title={'Когда придёт:'}
                Icon={CalendarSecond}
                value={date}
            />
            <ListItemWithIcon
                isBiggerFont={true}
                title={'Что будет делать:'}
                Icon={Electricity}
                value={<Paragraph4 $color={COLORS.TextPrimary} dangerouslySetInnerHTML={{ __html: engineerText }}/>}
            />
            <ListItemWithIcon
                isBiggerFont={true}
                title={'Как подготовиться:'}
                Icon={House}
                value={<Paragraph4 $color={COLORS.TextPrimary} dangerouslySetInnerHTML={{ __html: howToPrepareText }}/>}
            />
            <ListItemWithIcon
                isBiggerFont={true}
                Icon={Clock}
                value={'Все работы займут около ' + sla + '.'}
            />
        </InfoBlock>
    );
};

export default EmployeeVisit;
